// ==============================|| APP CONFIGURATION ||============================== //

export interface AppConfig {
  id: string;
  name: string;
  url: string;
}

export const APPS: AppConfig[] = [
  {
    id: "labs",
    name: "Labs",
    url: import.meta.env.VITE_APP_LABS_URL || "https://labs.mytobyai.com/",
  },
  {
    id: "dash",
    name: "Dash",
    url: import.meta.env.VITE_APP_DASH_URL || "https://dash.mytobyai.com/",
  },
];

/**
 * Detect the current app based on the current URL
 * @returns The id of the current app ('labs' or 'dash')
 */
export const getCurrentApp = (): string => {
  const currentUrl = window.location.href;

  // Check if current URL matches Labs URL
  const labsUrl =
    import.meta.env.VITE_APP_LABS_URL || "https://labs.mytobyai.com/";
  if (currentUrl.includes(new URL(labsUrl).hostname)) {
    return "labs";
  }

  // Check if current URL matches Dash URL
  const dashUrl =
    import.meta.env.VITE_APP_DASH_URL || "https://dash.mytobyai.com/";
  if (currentUrl.includes(new URL(dashUrl).hostname)) {
    return "dash";
  }

  // Default to labs for localhost and other cases
  if (currentUrl.includes("localhost")) {
    return "labs";
  }

  // Default fallback
  return "labs";
};
